import { Box, Card, CardBody, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { FiClock } from "react-icons/fi";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { momentLocaleFor } from "../../../../common/formatting/i18nFormatters";
import { formatShortDate } from "../utils/displayFormatters";

export const EventDeadlineHighlight = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t, i18n } = useTranslation();
  const locale = momentLocaleFor(i18n.language);
  const deadline = moment(event.bidSubmissionDeadline);
  const daysLeft = Math.max(0, Math.ceil(deadline.diff(moment(), "hours") / 24));

  return (
    <Card variant="outline" rounded="xl" bg="smPrimarySofter" borderColor="smPrimarySoft">
      <CardBody px={{ base: "4", md: "6" }} py={{ base: "5", md: "5" }}>
        <Flex align="center" justify="space-between" gap="4">
          <Flex align="center" gap="4">
            <Flex
              width={{ base: "44px", md: "52px" }}
              height={{ base: "44px", md: "52px" }}
              rounded="full"
              bg="smBackground"
              align="center"
              justify="center"
              flexShrink="0"
            >
              <Icon as={FiClock} boxSize="6" color="smPrimary" />
            </Flex>
            <Stack spacing="0">
              <Text
                fontSize="xs"
                fontWeight="semibold"
                color="smPrimary"
                textTransform="uppercase"
                letterSpacing="wide"
              >
                {t("Bid deadline")}
              </Text>
              <Text fontSize={{ base: "md", md: "lg" }} fontWeight="semibold" color="smText">
                {formatShortDate(event.bidSubmissionDeadline, locale)} {t("at_time")} {deadline.format("HH:mm")}
              </Text>
            </Stack>
          </Flex>

          <Box textAlign="right">
            <Text fontSize={{ base: "4xl", md: "5xl" }} fontWeight="bold" color="smPrimary" lineHeight="1">
              {daysLeft}
            </Text>
            <Text
              fontSize="xs"
              fontWeight="semibold"
              color="smPrimary"
              textTransform="uppercase"
              letterSpacing="wide"
              mt="1"
            >
              {t("days_left", { count: daysLeft })}
            </Text>
          </Box>
        </Flex>
      </CardBody>
    </Card>
  );
};
